import { Directive, HostBinding, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[mtgTeamBg]',
})
export class TeamBgDirective {
  @Input('mtgTeamBg')
  teamId: number;

  constructor(private sanitizer: DomSanitizer) {
  }

  @HostBinding('style.background')
  get backgroundImage(): any {
    const validTeamIds = [
      384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399,
      400, 401, 402, 403, 404, 405, 406, 407, 586, 587, 588, 589, 591, 592, 593, 594,
      595, 596, 597, 598, 599, 600, 601, 602, 603, 604, 605, 606, 607, 608, 609, 610,
      612, 627,
    ];
    if (!validTeamIds.includes(this.teamId)) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustStyle(`url(/assets/teams/${this.teamId}.png) no-repeat 0 0`);
  }
}
